import { useNavigate } from 'core/router/useNavigate';
import { useCallback } from 'react';
import { useParams } from 'react-router';
import { BulkRetargetingRoutes } from 'sections/bulk-retargeting-campaigns/routes';

export const useReturnToDashboard = () => {
  const { siteId } = useParams<{ siteId: string }>();
  const navigate = useNavigate();

  return useCallback(() => {
    navigate(BulkRetargetingRoutes.LIST, { siteId });
  }, [navigate, siteId]);
};
